module.exports = __webpack_public_path__ + "static/media/fragrances.7ccac433.webp";